import React from 'react';
import classNames from 'classnames';
import mainStyles from '../../../styles.module.scss';

export const SubmitContractComponent = ({ isSubmitContractLoading, handleSubmitContract, disabled }) => {
  return (
    <button
      id="submitContractButton"
      className={classNames(mainStyles.regularBtn, { [mainStyles.actionButton]: true })}
      onClick={handleSubmitContract}
      disabled={disabled}
    >
      {isSubmitContractLoading ? 'SUBMITTING...' : 'SUBMIT'}
    </button>
  );
};
